export default {
    getWindowWidthInRem() {
        return window.innerWidth / parseFloat(getComputedStyle(document.querySelector('html'))['font-size']);
    },

    removeTrailingSlash(str) {
        return str.replace(/\/+$/, '');
    }
};